module.exports = __webpack_public_path__ + "static/media/icon-comparison-right.2218679e.png";